import { Badge, Box, Group, Stack, Text } from '@mantine/core';

const ReasonCell = ({ cell }) => {
    const { column, row } = cell;
    const rowData = row.original;
    return (
        <Box
            style={{
                display: 'flex',
                alignItems: 'center',
                gap: '16px',
            }}>
            <Stack gap={0}>
                <Text>{rowData.reason}</Text>
            </Stack>
        </Box>
    );
};

const ReasonColumn = () => ({
    accessorKey: 'reason',
    header: 'Reason',
    size: 2,
    minSize: 200,
    Cell: ({ cell }) => <ReasonCell cell={cell} />,
});
export default ReasonColumn;
